import Pager from './pager'
import errorMessage from './errorMessage'
let install = (Vue) => {
  if (install.installed) return
  Vue.use(Pager)
  Vue.use(errorMessage)
}
export default install



// WEBPACK FOOTER //
// ./src/cdpBase/mixins/index.js